import React from 'react';

export interface RefundData {
	date: string;
	amount: string;
	customerId: string;
	transactionReference: string;
	originalTransactionDate:string;
	refundReceipt:string;
	status: any;
	action: any;
}

export const ColumnRefund = [
	{
		Header: 'Amount',
		accessor: 'amount',
	},
	{
		Header: 'Customer ID',
		accessor: 'customerId',
	},
	{
		Header: 'Transaction reference',
		accessor: 'transactionReference',
	},
	{
		Header: 'Date',
		accessor: 'date',
	},
	{
		Header: 'Original Transaction Date',
		accessor: 'originalTransactionDate',
	},
	{
		Header: 'Refund Receipt',
		accessor: 'refundReceipt',
	},
	{
		Header: 'Status',
		accessor: 'status',
	},
	{
		Header: 'Action',
		accessor: 'action',
	},
];
